export enum ActionTypes {
  fixed = 'fixed',
  crop = 'crop',
  min = 'min',
}

export enum LandingCategory {
  general = 'general',
  photo_product = 'photo_product',
  video_product = 'video_product',
  partnership = 'partnership',
  marketing = 'marketing',
  homepage = 'homepage',
  template = 'template',
  maximizer = 'maximizer',
  color = 'color',
  hub = 'hub',
  fonts = 'fonts',
}

export enum UploadType {
  multiple_upload = 'multiple_upload',
  single_upload = 'single_upload',
}

export enum TOGGLE_POSITION_ENUM {
  left,
  right,
}

export enum AnalyticEventTypes {
  popup_action = 'popup_action',
  upload_complete = 'upload_complete',
  page_click = 'page_click',
  experiment_variant_trigger = 'experiment_variant_trigger',
  registration_done = 'registration_done',
  subscription_button_click = 'subscription_button_click',
  subscription_offer_open = 'subscription_offer_open',
  page_open = 'page_open',
  page_view = 'page_view',
  object_export = 'object_export',
  widget_result_seen = 'widget_result_seen',
  search_filter_menu_click = 'search_filter_menu_click',
}

export enum StickyBarBackgroundTypes {
  GradientPositive = 'gradient.positive',
  GradientPrimary = 'gradient.primary',
  Positive = 'positive',
  Negative = 'negative',
}

export enum ButtonColorOption {
  Primary = 'Primary',
  Secondary = 'Secondary',
  Hyperlink = 'Hyperlink',
}

export enum SubscriptionTypes {
  pro = 'pro',
  plus = 'plus',
  free = 'free',
  gold = 'gold_old',
  max_starter = 'max_starter',
  max_performance = 'max_performance',
}

export enum FetchPriority {
  High = 'high',
  Low = 'low',
}

export enum ImageSizes {
  MOBILE_BREAKPOINT = 480,
  TABLET_BREAKPOINT = 768,
  DESKTOP_BREAKPOINT = 1200,
}
